module.exports = __webpack_public_path__ + "green-laurus-42b89532d9135511ad396e4ae127fa97.png";


//////////////////
// WEBPACK FOOTER
// ./app/javascript/components/image_generator/green-laurus.png
// module id = 104
// module chunks = 0 1